'use client'
import useSetSearchParams from 'app/hooks/useSetSearchParams'
import { cn } from 'app/lib/utils'
import { Input } from 'ui/input'
import { useSearchParams } from 'next/navigation'
import { HTMLProps } from 'react'
import { IoIosSearch } from 'react-icons/io'

const SearchInput = ({
    placeholderText,
    className,
    icon,
    iconClassName,
    paramKey,
    iconWrapperClassName
}: {
    placeholderText: string
    className?: HTMLProps<HTMLElement>['className']
    iconClassName?: HTMLProps<HTMLElement>['className']
    iconWrapperClassName?: HTMLProps<HTMLElement>['className']
    icon?: boolean
    paramKey?: string
}) => {
    const searchParams = useSearchParams()
    const { addParam } = useSetSearchParams()

    return (
        <div className={`${icon ? 'flex items-center  w-full relative ' : ''}`}>
            {icon && (
                <div
                    className={cn(
                        'absolute inset-y-0 top-1/2 -translate-y-1/2 left-0 flex items-center pl-2  pointer-events-none',
                        iconWrapperClassName
                    )}
                >
                    <IoIosSearch className={cn('size-5 text-foreground-muted', iconClassName)} />
                </div>
            )}
            <Input
                defaultValue={searchParams.get(paramKey || 'query')?.toString() || ''}
                onChange={e => addParam(paramKey || 'query', e.target.value)}
                placeholder={placeholderText}
                className={cn(`${icon ? 'pl-8' : ''}`, className)}
            />
        </div>
    )
}
export default SearchInput
